import { Button, Modal, Space, Table } from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { trackingLinkSelector } from "../../feature/tracking-links/trackingLinkSelector";
import {
  getTrackingLinksRequest,
  removeTrackingLinksRequest,
} from "../../feature/tracking-links/trackingLinkSlice";
import { appConfig } from "../../utils/appConfig";
import AddTrackingLink from "./AddTrackingLink";

const TrackingLinks = () => {
  const [isDisplayModal, setDisplayModal] = useState(false);
  const [trackingLink, setTrackingLink] = useState();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(appConfig.PAGE_SIZE);
  const [selectedTrackingLink, setSelectedTrackingLink] = useState();
  const [displayRemoveModal, setDisplayRemoveModal] = useState(false);
  const {
    listTrackingLink,
    total,
    isGetTrackingLinks,
    isCreateTrackingLinks,
    isUpdateTrackingLink,
    isRemoveTrackingLink,
  } = useSelector(({ trackingLinksState }) =>
    trackingLinkSelector(trackingLinksState)
  );
  const dispatch = useDispatch();
  const totalRef = useRef(total);

  const columns = useMemo(() => {
    const result = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Code",
        dataIndex: "code",
        key: "code",
      },
      {
        title: "Website Address",
        dataIndex: "link",
        key: "link",
        render: (link) => (
          <a href={link} target="_blank" rel="noreferrer">
            {link}
          </a>
        ),
      },
      {
        title: "Assign to Referral Partner",
        dataIndex: "partner",
        key: "partner",
        render: (values) => (
          <div>{`${values?.firstName || ""} ${values?.lastName || ""}`}</div>
        ),
      },
      {
        title: "Assign to Partners belong to Commission Programs",
        dataIndex: "commissionPrograms",
        key: "commissionPrograms",
        render: (array) => {
          const commission = array.map((item) => item.title);
          return commission.join(", ");
        },
      },
      {
        title: "Action",
        key: "action",
        render: (_, item) => (
          <Space size="middle">
            <span
              className="link-pointer"
              onClick={() => onEditTrackingLink(item)}
            >
              Edit
            </span>
            <span
              className="pointer ant-typography ant-typography-danger"
              onClick={() => onRemoveTrackingLink(item)}
            >
              Delete
            </span>
          </Space>
        ),
      },
    ];
    return result;
  }, []);

  const onCancelModal = (value) => {
    setDisplayModal(false);
    setTrackingLink(undefined);
  };

  const onEditTrackingLink = (data) => {
    setDisplayModal(true);
    setTrackingLink(data);
  };

  const onRemoveTrackingLink = (data) => {
    setSelectedTrackingLink(data);
    setDisplayRemoveModal(true);
  };

  const onConfirmRemove = () => {
    selectedTrackingLink &&
      dispatch(removeTrackingLinksRequest(selectedTrackingLink));
    setDisplayRemoveModal(false);
  };

  const loadData = (newPage, sizeChanger) => {
    const limit = sizeChanger || pageSize;
    setPage(newPage);
    setPageSize(sizeChanger);
    dispatch(
      getTrackingLinksRequest({
        limit,
        offset: (newPage - 1) * limit,
      })
    );
  };

  useEffect(() => {
    if (
      total < totalRef.current &&
      page !== total / pageSize &&
      page > 1 &&
      total > 0 &&
      total % pageSize === 0
    ) {
      loadData(page - 1, pageSize);
      totalRef.current = total;
      return;
    }
    if (total > totalRef.current) {
      loadData(1, pageSize);
      totalRef.current = total;
      return;
    }
    loadData(page, pageSize);
    totalRef.current = total;
    // eslint-disable-next-line
  }, [total]);

  return (
    <div>
      <div className="title-page">Referral Tracking Links</div>
      <Button
        type="primary"
        className="f-right mt-25 mb-25"
        onClick={() => setDisplayModal(true)}
      >
        Add a Referral Tracking Link
      </Button>
      <Table
        columns={columns}
        dataSource={listTrackingLink}
        bordered
        pagination={{
          showTotal: (total) => `Total ${total} results`,
          defaultPageSize: appConfig.PAGE_SIZE,
          pageSize,
          defaultCurrent: 1,
          current: page,
          showSizeChanger: true,
          pageSizeOptions: [appConfig.PAGE_SIZE, 25, 50].sort((a, b) => a - b),
          total,
          onChange: (page, sizeChanger) => loadData(page, sizeChanger),
        }}
        loading={
          isGetTrackingLinks ||
          isCreateTrackingLinks ||
          isUpdateTrackingLink ||
          isRemoveTrackingLink
        }
        rowKey="_id"
      />
      {isDisplayModal && (
        <AddTrackingLink onCancel={onCancelModal} data={trackingLink} />
      )}
      {displayRemoveModal && (
        <Modal
          title="Are you sure?"
          visible={true}
          width={"50%"}
          className="modal-w-600"
          onOk={onConfirmRemove}
          onCancel={() => setDisplayRemoveModal(false)}
        >
          <p>
            Do you really want to delete this tracking link? This process cannot
            be undone.
          </p>
        </Modal>
      )}
    </div>
  );
};

export default TrackingLinks;
